<template>
  <SummaryPanel title="Auxiliary Engine" :badges="badges" :anchor-id="anchorId">
    <div class="panel-mini-row aux-engine-donuts">
      <div v-if="runningItems.length">
        <DonutChart
          :data="runningItems"
          label-key="label"
          value-key="raw"
          :colors="runningColors"
          :width="96"
          :height="96"
          :show-legend="false"
        />
        <div class="panel-caption">Running</div>
      </div>
      <div v-if="fuelItems.length">
        <DonutChart
          :data="fuelItems"
          label-key="label"
          value-key="raw"
          :colors="fuelColors"
          :width="96"
          :height="96"
          :show-legend="false"
        />
        <div class="panel-caption">Fuel</div>
      </div>
    </div>

    <div class="panel-table-scroll aux-engine-table">
      <table class="table panel-table">
        <thead class="thead-light">
          <tr>
            <th>Engine</th>
            <th>Running</th>
            <th>Fuel</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(engine, index) in model.engines" :key="engine.key">
            <td>
              <span class="aux-engine-swatch" :style="{ background: engineColor(index) }"></span>
              {{ engine.key }}
            </td>
            <td>{{ formatRunning(engine) }}</td>
            <td>{{ formatFuel(engine) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </SummaryPanel>
</template>

<script>
import { formatNum } from '@/util/number';
import { toDuration } from '@/util/date';
import SummaryPanel from './SummaryPanel.vue';
import DonutChart from '../charts/DonutChart.vue';

export default {
  name: 'AuxEnginePanel',
  components: {
    SummaryPanel,
    DonutChart,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    badges: {
      type: Array,
      default: () => [],
    },
    anchorId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      // satu palet buat dua donut, warna ikut engine
      palette: ['#fd7e14', '#20c997', '#e83e8c', '#0d6efd', '#6f42c1', '#795548'],
    };
  },
  computed: {
    runningItems() {
      return this.itemsBy('runningSeconds');
    },
    fuelItems() {
      return this.itemsBy('fuelLiters');
    },
    runningColors() {
      return this.runningItems.map((item) => item.color);
    },
    fuelColors() {
      return this.fuelItems.map((item) => item.color);
    },
  },
  methods: {
    engineColor(index) {
      return this.palette[index % this.palette.length];
    },
    // index engine diambil sebelum filter biar warna cocok sama tabel
    itemsBy(field) {
      return this.model.engines
        .map((e, index) => ({ label: e.key, raw: e[field], color: this.engineColor(index) }))
        .filter((item) => item.raw > 0);
    },
    formatRunning(engine) {
      return toDuration(engine.runningSeconds);
    },
    formatFuel(engine) {
      return `${formatNum(engine.fuelLiters, 2)} L (${formatNum(engine.fuelShare, 1)}%)`;
    },
  },
};
</script>

<style src="./summaryPanel.css"></style>

<style scoped>
.aux-engine-donuts {
  justify-content: center;
}

.aux-engine-table {
  margin-top: 8px;
}

.aux-engine-swatch {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  margin-right: 4px;
}
</style>
